"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskInfoTeacherContainer = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const DSTP001_Regist_Child_1 = require("../DSTP001_Regist_Child");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const react_redux_1 = require("react-redux");
const account_1 = require("../../../../base/account");
const TaskInfoTeacherContainer = ({ isTest, item, isSurvey = false, hideName = false, compact = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const assignmentRef = (0, react_1.useRef)(null);
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [assignmentName, setAssignmentName] = (0, react_1.useState)(''); // 과제명
    const [className, setClassName] = (0, react_1.useState)(''); // 수업명
    const [startDate, setStartDate] = (0, react_1.useState)(''); // 시작일
    const [endDate, setEndDate] = (0, react_1.useState)(''); // 마감일
    const [duration, setDuration] = (0, react_1.useState)(0); // 시험 시간
    const [questionType, setQuestionType] = (0, react_1.useState)(''); // 문제 유형
    const [attachFileList, setAttachFileList] = (0, react_1.useState)([]); // 첨부파일
    (0, react_1.useEffect)(() => {
        if (!item)
            return;
        const questionType = item.type === 'OMR (기본형)' || item.type === 'OMR (자유형)'
            ? item.type +
                `${item.subject !== '' ? ' - ' + t(`assignment.${item.subject}`) : ''}`
            : item.type;
        setClassName(item.conference_name);
        setAssignmentName(item.title);
        setStartDate((0, moment_1.default)(item.startline).format(isTest ? 'YYYY-MM-DD' : 'YYYY-MM-DD, HH:mm'));
        setDuration(item.duration);
        setEndDate((0, moment_1.default)(item.deadline).format('YYYY-MM-DD, HH:mm'));
        setQuestionType(questionType);
        setAttachFileList(item.attachments);
    }, [item]);
    (0, react_1.useEffect)(() => {
        if (assignmentRef.current)
            assignmentRef.current.value = item.title;
    }, [item.title]);
    //수업명, 테스트명
    const renderNameContainer = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.class_name')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement("div", { className: "placeholder_wrap" },
                    react_1.default.createElement("p", null, className ? className : t('assignment.noClass'))))),
        !hideName && (react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.testname')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement("div", { className: "placeholder_wrap" },
                    react_1.default.createElement("p", null, assignmentName))))))), [className, assignmentName, hideName]);
    const renderDateInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.startDate')),
            react_1.default.createElement("div", { className: "fext-field", style: { minWidth: isTablet ? '130px' : undefined } },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: startDate }))),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.endDate')),
            react_1.default.createElement("div", { className: "fext-field", style: { minWidth: isTablet ? '130px' : undefined } },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: endDate }))))), [startDate, endDate]);
    const renderTaskInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null, isTablet ? (react_1.default.createElement("div", { className: "task-info-wrap assignment-info" },
        react_1.default.createElement("div", { className: "field-short", style: { gap: '12px' } }, renderDateInfo))) : (renderDateInfo))), [questionType, isSurvey]);
    const renderDateContainer = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "test-date-container" },
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.progress_date')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: startDate }))),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.duration')),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: duration }),
                react_1.default.createElement("div", null, t('assignment.minute')))))), [startDate, duration]);
    // p.41: 모바일 상단 고정 기본정보 — 비활성 입력란 형태 대신 정보를 간략 텍스트(라벨:값)로 축소.
    // 첨부 파일은 예시 레이아웃대로 시작일/마감일 사이에 배치.
    if (compact) {
        const downloadAttach = (url) => {
            if (!isTeacher && item.status !== 'open')
                return;
            const formattedUrl = url.replace(/\s/g, '%20');
            const a = document.createElement('a');
            a.href = formattedUrl;
            a.download = url.split('/').pop() || 'download';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };
        const hasAttach = (attachFileList || []).length > 0;
        // 시작일/마감일과 동일하게 라벨:값 텍스트 행으로 표기 (파일명은 클릭 시 다운로드)
        const renderCompactAttach = (react_1.default.createElement("div", { className: "compact-row" },
            react_1.default.createElement("span", { className: "compact-label" }, t('assignment.attachFile')),
            react_1.default.createElement("span", { className: "compact-value" }, hasAttach
                ? attachFileList.map((file, index) => {
                    const name = typeof file === 'string' ? file.split('/').pop() : file?.name;
                    return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                        index > 0 && ', ',
                        typeof file === 'string' ? (react_1.default.createElement("span", { className: "compact-attach-file", onClick: () => downloadAttach(file) }, name)) : (name)));
                })
                : t('assignment.noAttachFilePlaceholer'))));
        return (react_1.default.createElement("div", { className: "task-info-compact" }, isTest ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "compact-row" },
                react_1.default.createElement("span", { className: "compact-label" }, t('assignment.progress_date')),
                react_1.default.createElement("span", { className: "compact-value" }, startDate)),
            react_1.default.createElement("div", { className: "compact-row" },
                react_1.default.createElement("span", { className: "compact-label" }, t('assignment.duration')),
                react_1.default.createElement("span", { className: "compact-value" }, `${duration}${t('assignment.minute')}`)),
            renderCompactAttach)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "compact-row" },
                react_1.default.createElement("span", { className: "compact-label" }, t('assignment.startDate')),
                react_1.default.createElement("span", { className: "compact-value" }, startDate)),
            renderCompactAttach,
            react_1.default.createElement("div", { className: "compact-row" },
                react_1.default.createElement("span", { className: "compact-label" }, t('assignment.endDate')),
                react_1.default.createElement("span", { className: "compact-value" }, endDate))))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isTest ? (react_1.default.createElement(react_1.default.Fragment, null,
            renderNameContainer,
            renderDateContainer)) : (react_1.default.createElement(react_1.default.Fragment, null,
            isDesktop || hideName ? null : (react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('assignment.subjectName')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement("div", { className: "placeholder_wrap" },
                        react_1.default.createElement("p", null, assignmentName))))),
            renderTaskInfo)),
        react_1.default.createElement(DSTP001_Regist_Child_1.AttachFile, { attachFileList: attachFileList, isRegist: false, isTeacher: isTeacher, showRegist: false, download: item.status === 'open' ? true : false })));
};
exports.TaskInfoTeacherContainer = TaskInfoTeacherContainer;
